import Config from "@_configs/api.config";
import { authHeader, sessionHeader } from "@_utils/helpers";

export const invoiceService = {
  downloadInvoice,
  generateInvoice,
};

function downloadInvoice(invoiceId) {
  let url =
    Config.API_ROOT +
    `cases/${sessionStorage.getItem("case_id")}/invoice/${invoiceId}`;

  return fetch(url, {
    method: "GET",
    headers: {
      ...authHeader(),
      ...sessionHeader(),
      "Content-Type": "application/json",
    },
  });
}

function generateInvoice() {
  let url =
    Config.API_ROOT + `cases/${sessionStorage.getItem("case_id")}/invoice/`;

  const requestOptions = {
    method: "POST",
    headers: {
      ...authHeader(),
      ...sessionHeader(),
    },
  };
  return fetch(url, requestOptions);
}
